import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { KeyValue, PayloadArchivDocumentList, PayloadBankverbindungList, PayloadIEAusgangList, PayloadIEEingangList, PayloadMaklerFileList, PayloadPersonResultList, PayloadTerminList, PayloadVertreter, PayloadVertreterBuchungList, VersbestRequest } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestVertreterService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchVertreter(searchParams: KeyValue<string, any>[]): Observable<PayloadPersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadPersonResultList>(
        this.baseUrl + '/vertreter/suche',
        options);
  }

  downloadVersicherungsbestaetigung(request: VersbestRequest): Observable<HttpResponse<Blob>> {
    return this.http
      .post<Blob>(this.baseUrl + '/versicherungsbestaetigung/download',
        request,
        {
          ...this.httpOptions,
          observe:      'response',
          responseType: 'blob' as 'json'
        });
  }

  public getVertreter(personId: number): Observable<PayloadVertreter> {
    return this.http
      .get<PayloadVertreter>(this.baseUrl + '/vertreter/' + personId, this.httpOptions);
  }

  public getVertreterVersion(personId: number, version: number): Observable<PayloadVertreter> {
    return this.http
      .get<PayloadVertreter>(this.baseUrl + '/vertreter/' + personId + '/version/' + version, this.httpOptions);
  }

  public getVertreterBuchungszeilenProvision(personId: number): Observable<PayloadVertreterBuchungList> {
    return this.http
      .get<PayloadVertreterBuchungList>(this.baseUrl + '/vertreter/' + personId + '/buchungszeilen/provision', this.httpOptions);
  }

  public getVertreterBuchungszeilenAuszahlungen(personId: number): Observable<PayloadVertreterBuchungList> {
    return this.http
      .get<PayloadVertreterBuchungList>(this.baseUrl + '/vertreter/' + personId + '/buchungszeilen/auszahlungen', this.httpOptions);
  }

  public getVertreterBuchungszeilenSaldosteuer(personId: number): Observable<PayloadVertreterBuchungList> {
    return this.http
      .get<PayloadVertreterBuchungList>(this.baseUrl + '/vertreter/' + personId + '/buchungszeilen/saldosteuer', this.httpOptions);
  }

  public getVertreterBriefe(personId: number): Observable<PayloadArchivDocumentList> {
    return this.http
      .get<PayloadArchivDocumentList>(this.baseUrl + '/vertreter/' + personId + '/documents', this.httpOptions);
  }

  public getVertreterBvb(personId: number): Observable<PayloadBankverbindungList> {
    return this.http
      .get<PayloadBankverbindungList>(this.baseUrl + '/vertreter/' + personId + '/bankverbindung', this.httpOptions);
  }

  public getVertreterTermine(personId: number): Observable<PayloadTerminList> {
    return this.http
      .get<PayloadTerminList>(this.baseUrl + '/vertreter/' + personId + '/termine', this.httpOptions);
  }

  public getVertreterZahlungenAusgang(personId: number): Observable<PayloadIEAusgangList> {
    return this.http
      .get<PayloadIEAusgangList>(this.baseUrl + '/vertreter/' + personId + '/zahlungen/ausgang', this.httpOptions);
  }

  public getVertreterZahlungenEingang(personId: number): Observable<PayloadIEEingangList> {
    return this.http
      .get<PayloadIEEingangList>(this.baseUrl + '/vertreter/' + personId + '/zahlungen/eingang', this.httpOptions);
  }

  public getVertreterOMDSDocumentList(personId: number): Observable<PayloadMaklerFileList> {
    return this.http
      .get<PayloadMaklerFileList>(this.baseUrl + '/vertreter/' + personId + '/download/omds', this.httpOptions);
  }

  public printVertreterDocument(personId: number, docId: string): Observable<HttpResponse<Blob>> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'docId',
        value: docId
      },
    ] as KeyValue<string, any>[]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<Blob>(this.baseUrl + '/vertreter/' + personId + '/download/download', {
        ...options,
        observe:      'response',
        responseType: 'blob' as 'json'
      });
  }
}
